import resourceService from './resource_service';

const modelName = 'app-step';

const attributes = {
  dispenseType: '',
  volume: '',
  appOrder: '',
  gallons: '',
  ounces: '',
  weight: '',
  minutes: '',
  seconds: '',
  forcedVolume: '',
};

const readOnlyAttributes = ['volume'];

const relationships = {
  app: {
    jsonApi: 'hasOne',
  },
  chemical: {
    jsonApi: 'hasOne',
    update: true,
  },
};

export default resourceService(modelName, attributes, relationships, readOnlyAttributes);
